// Static product catalogue — this is the real listing, not mock data

export const DIES = [
  { id: 'nv8-1', name: 'NV8-1 PIXEL', blurb: 'the entry core — one lane, honest output', vram: '128K', fill: '2 Mpx/s', lanes: 4, scanline: 1, ethPerHour: 0.0004, gpu: 'RTX A4000' },
  { id: 'nv8-2', name: 'NV8-2 CANVAS', blurb: 'double-buffered planes for smooth scrolling work', vram: '512K', fill: '9 Mpx/s', lanes: 8, scanline: 2, ethPerHour: 0.0013, gpu: 'RTX A5000' },
  { id: 'nv8-4', name: 'NV8-4 VECTOR', blurb: 'line-by-line tricks for the demo crowd', vram: '2M', fill: '48 Mpx/s', lanes: 16, scanline: 4, ethPerHour: 0.0041, gpu: 'RTX 4090' },
  { id: 'nv8-8', name: 'NV8-8 PRISM', blurb: 'the whole die lit — every lane at once', vram: '8M', fill: '160 Mpx/s', lanes: 32, scanline: 8, ethPerHour: 0.012, gpu: 'A100 80GB' },
];

export const TOKEN_INFO = {
  product: 'NANOVRAM',
  ticker: '$NVRM',
  ground: 'Robinhood chain',
  cartId: '0x3fA9c214bE07d5a8Ce1194fD22aB86e64ac21511',
};

// Receiving wallet for rent payments — live NANOVRAM treasury (Ethereum Mainnet)
export const PAYMENT_ADDRESS = '0x58bFa2F49D2001877A78F51d4a67078Ce7800825';

export const BYTE_SUGGESTIONS = [
  'what is moving today',
  'where is the real volume',
  'what is $NVRM',
  'why no signal instead of zero',
];

export const fmtUsd = (v) => {
  if (v === null || v === undefined) return null;
  if (v >= 1000) return '$' + v.toLocaleString('en-US', { maximumFractionDigits: 2 });
  if (v >= 1) return '$' + v.toFixed(2);
  return '$' + v.toPrecision(4);
};

export const fmtBig = (v) => {
  if (v === null || v === undefined) return null;
  if (v >= 1e12) return '$' + (v / 1e12).toFixed(2) + 'T';
  if (v >= 1e9) return '$' + (v / 1e9).toFixed(2) + 'B';
  if (v >= 1e6) return '$' + (v / 1e6).toFixed(2) + 'M';
  return '$' + Math.round(v).toLocaleString();
};

export const fmtCount = (v) => {
  if (v === null || v === undefined) return null;
  if (v >= 1e9) return (v / 1e9).toFixed(2) + 'B';
  if (v >= 1e6) return (v / 1e6).toFixed(2) + 'M';
  if (v >= 1e3) return (v / 1e3).toFixed(2) + 'K';
  return String(v);
};
